import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { FeatureTogglesFacade } from '@cigna/features';
import { UserFacade } from '@cigna/chcp/shared/user-profile-data-access';
import { AuthFacade } from '@cigna/chcp/auth/data-access';
import { DashboardFacade } from '@cigna/chcp/dashboard/data-access';
import { Entitlement } from '@cigna/chcp/auth/util';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'cigna-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  firstName$ = this.userFacade.firstName$;
  contactUpdated$ = this.userFacade.contactUpdated$;
  impersonator$ = this.authFacade.isImpersonator$;
  restrictedImpersonator$ = this.authFacade.isRestrictedImpersonator$;

  hasClaimSearch$ = this.authFacade.hasOneOfEntitlements$([
    Entitlement.ClaimsSearch,
  ]);
  isOhpUser$ = this.authFacade.isOhpUser$;
  isDentalUser$ = this.authFacade.isDentalUser$;
  hasPatientSearch$ = this.authFacade.hasOneOfEntitlements$([
    Entitlement.PatientSearch,
  ]);
  hasDelegation$ = this.authFacade.hasOneOfEntitlements$([
    Entitlement.DelegationAccessAndViews,
  ]);

  newFeaturesBanner$ = this.featureToggleFacade.featuresEnabled([
    'newFeaturesBanner',
  ]);
  messageCenterFeatureFlag$ = this.featureToggleFacade.featuresEnabled(
    ['claim360', 'messageCenteDashboard'],
    'AND',
  );

  latestUpdates$ = this.dashboardFacade.latestUpdates$;
  newFeatures$ = this.dashboardFacade.newFeatures$;
  newFeatureBanners$ = this.dashboardFacade.newFeatureBanners$;
  latestUpdatesLoading$ = this.dashboardFacade.latestUpdatesLoading$;
  messages$ = this.dashboardFacade.messages$;

  constructor(
    private userFacade: UserFacade,
    private authFacade: AuthFacade,
    private featureToggleFacade: FeatureTogglesFacade,
    public dashboardFacade: DashboardFacade,
  ) {}

  ngOnInit() {
    this.dashboardFacade.getLatestUpdates();
    combineLatest([this.messageCenterFeatureFlag$, this.isDentalUser$])
      .pipe(take(1))
      .subscribe(([isFeatureEnabled, isDental]) => {
        if (isFeatureEnabled && isDental) {
          this.dashboardFacade.fetchMessages();
        }
      });
  }
}
